import React, {useEffect, useState } from "react";
import Button from "../../components/common/Button";
import Input from "../../components/common/Input";
import Radio from "../../components/common/Radio";
import Jumpbotron from "../../components/common/Jumpbotron";
import Select from "../../components/common/Select";
import Modal from "../../components/common/Modal";
import DatosProveedor from "../../components/common/DatosProveedor";
import Tab from "../../components/common/Tab";
import { useDispatch } from "react-redux";
import {initDataProveedorReferencia_Val,initDataProveedorReferenciaArray_Val,
        initDataProveedorReferencia_Ex, initDataProveedorReferenciaArray_Ex } from "../../utils/options";
import CustomTable from "../../components/CustomTable";
import TableRimac from "../../components/common/Table/TableRimac";
import { hideLoading, showLoading } from "../../redux/actions/general";
import { headDataUsers } from "../../components/CustomTable/headData";
import usersData from "../../components/CustomTable/usersData";
import addUserIcon from "../../assets/icon_add_user.svg";
import deleteLogo from "../../assets/gl_delete-20.svg";
import "./styles.scss";
import { Checkbox } from "aws-amplify-react";
import { callService } from "../../amplify/callService";
import { CONSTANTES } from "../../utils/Constantes";
import Alert from "../../components/common/Alert";
import { getColorByStatusFlag } from "../../utils/utils";
import { iconEdit, iconCheck } from "../../components/common/icons";
import Chip from "../../components/common/Chip";
import Pagination from "../../components/common/Pagination";
import InputWithDropdown from "../../components/common/InputWithDropdown";
import Validate from "../../utils/Validate";

const ProveedoresReferencia = ({dataT, keyIndex, handleActualizarFicha, handleChangePaso}) => {
  const dispatch = useDispatch();

  const [openAdd, setOpenAdd] = useState(false);
  const [tagBody, setTagBody] = useState("nostate");  
  const [showAlert, setShowAlert] = useState({
    show: false,
    title: "",
    message: "",
    type: "",
  });
  const [currentPage, setCurrentPage] = useState();
  const [paginationData, setPaginationData] = useState({
    totalPages: 5,
  });
  const [data, setData] = useState(Validate.extraerAtributos(initDataProveedorReferencia_Ex, dataT, initDataProveedorReferenciaArray_Ex));
  const [validacion, setValidacion] = useState({referencia:[]});
  useEffect(() => {    
    setData(Validate.extraerAtributos(initDataProveedorReferencia_Ex, dataT, initDataProveedorReferenciaArray_Ex));
  }, [dataT]);
  const handleChange = (name, value, i) => {
    let jsonAd = {};    
    value = value.toUpperCase ? value.toUpperCase() : value;    
    setData({ ...data, [name]: value });
    if(value instanceof Array){
      validacion[name][i]=false;
      setValidacion({ ...validacion, [name]: validacion[name]});
    }else{
      setValidacion({ ...validacion, [name]: false });
    }
    
  };
  const validarFormulario = () => {
    let resp = true;
    for (var name in Object.assign({},initDataProveedorReferencia_Val,Validate.limpiarObjeto(data))) {
      //if (data.hasOwnProperty(name)){
        if(!data[name] ){
          validacion[name] = true;
          setValidacion({...validacion, [name]: true});
          resp = false;
          //break;
        }
        if(data[name] instanceof Array){
          let limpArr = Validate.limpiarArregloIdProveedor(data[name]);
          data[name] = limpArr.arr;
          if(!data[name][0]){
            if(!data[name][1]){
              if(data[name][2]){
                ((data[name])[0])={};
                ((data[name])[1])={};
                ((validacion[name])[0])={};
                ((validacion[name])[1])={};
              }
            }else{
              ((data[name])[0])={};
              ((validacion[name])[0])={};
            }
          }else{
            if(!data[name][1]){
              if(data[name][2]){
                ((data[name])[1])={};
                ((validacion[name])[1])={};
              }
            }
          }
          if(limpArr.delete.length>0)
            data[name+'Delete'] = limpArr.delete;
          let i=0;
          for(let elem of data[name]){
            for (var name2 in Object.assign({},initDataProveedorReferenciaArray_Val,Validate.limpiarObjeto(elem))) {
              //if (elem.hasOwnProperty(name2)){
                if(!elem[name2]){
                  console.log("LOGG"+(validacion[name]));
                  (validacion[name])[i] = (validacion[name])[i]?(validacion[name])[i]:{};
                  ((validacion[name])[i])[name2] = true;
                  setValidacion({...validacion, [name]: validacion[name]});
                  resp = false;
                }
                if(name2=='correo' && !Validate.validarEmail(elem[name2])){
                  (validacion[name])[i] = (validacion[name])[i]?(validacion[name])[i]:{};
                  ((validacion[name])[i])[name2] = true;
                  setValidacion({...validacion, [name]: validacion[name]});
                  resp = false;
                }
                if(name2=='numRuc' && !Validate.validarDocumento('RUC',elem[name2])){
                  (validacion[name])[i] = (validacion[name])[i]?(validacion[name])[i]:{};
                  ((validacion[name])[i])[name2] = true;
                  setValidacion({...validacion, [name]: validacion[name]});
                  resp = false;
                } 
              //}             
            }
            i++;
          }
        }
        /*if(name=='numDocumento' && !Validate.validarDocumento(data.idpTipoDocumento,data[name])){
          validacion[name] = true;
          setValidacion({...validacion, [name]: true});
          resp = false;
        }*/ 
      //}     
    }
    return resp;
  }

  const resetAlert = () => {
    setShowAlert({
      show: false,
      title: "",
      message: "",
      type: "",
    });
  };
  
  const resetForm =() => {
    
  };

  const resetMessage = (sec) =>
    setTimeout(() => {
      resetAlert();
    }, sec * 1000);
 

  const handleCloseModal = (value) => {
    setOpenAdd(value);
  };

  const handleChangeEnvioCorreo = (event) => {
    console.log('============', event)
  };

  const handleChangeEmail = (text) => {
    console.log('============', text);
    };


  const handleOpenAddModal = (tag) => {    
    setTagBody(tag);
    resetForm();
    setOpenAdd(true);
  };

  const handleShowModal = (row, tag) => {
    resetForm();
    if (!openAdd) setOpenAdd(true);
    setTagBody(tag);
    if (tag === "edit") fillEditForm(row);
  };

  const fillEditForm = (row)=> {
    console.log(row);
      
  };
  
  const handleCloseAddModal = () => {
    setOpenAdd(false);
  };

  const bodyModalAdd = () => {
    return (
      <div className="content customTable--bodyModal">
        <div className="title">
          <h4 className="title-05 margin-bottom-10">
            Registro para{" "}
            <span className="title-05 color-red">
              <strong>{ tagBody=="add" && ("agregar nueva") } { tagBody=="edit" && ("actualizar") } área</strong>
            </span>
          </h4>
        </div>
        <div className="form--line" />
        <div className="customTable--bodyModal-input">
          
        <div className="d-justify-space-between d-flex-column-m w100">
            <div className="areasLay__formulario--left2Columns">
              <Input label="Nombre de área" />
            </div>
            <div className="usersLay__formulario--right2Columns">
              <Select label="Estado"  />
            </div>
            
        </div>
        <div className="d-justify-space-between d-flex-column-m w100">
            <div className="areassLay__formulario--left2Columns">
            <Checkbox id="chkEnvioCorreo" label="Envío de Correo" />
            <label htmlFor="chkEnvioCorreo">Enviar correo de notificación</label>
            </div>
          
        </div>
        <br/>
        <div className="d-justify-space-between d-flex-column-m w100">
            <div className="areassLay__formulario--left2Columns">
            <Checkbox id="chkEnvioCorreoRecepcion" label="Envío de Correo Recepcion" />
            <label htmlFor="chkEnvioCorreoRecepcion">Correo de recepción de factura</label>
            </div>
            
            
        </div>
      
        </div>
      </div>
    );
  };  
    
  const handleClickRegisterModal = async () => {
      //const { dateTimeCreation, docNumber, clientDoc, id } = selectedRow;
    if(tagBody=="add")
    { 
        const body = {
          payload: {
            
          },
        };
        try {
          dispatch(showLoading());
          const response = await callService(
            "POST",
            CONSTANTES.APIS_PATH.insertArea,
            body
          );
          dispatch(hideLoading());
          // type == 0 => ok , type == 1 => error
          let error = response.data? response.data.type:null;
          if (response.ok && response.data && response.ok == true && error!='1') {
            resetForm();
            setShowAlert({
              show: true,
              title: "Correcto",
              message: response.data.data || "Se guardó el registró",
              type: "success",
            });
            resetMessage(5);
            handleCloseModal(false);            
            setCurrentPage(new Number(1));            
          } else {
            const mesaje = response.message || "Error al registrar";
            setShowAlert({
              show: true,
              title: "Error",
              message: mesaje,
              type: "error",
            });
            resetMessage(5);
          }
          // handleSearchEndpoint();
        } catch (ex) {
          console.log(ex)
          dispatch(hideLoading());
        }
      
    }
    
  };

  const handleSearchEndpoint = async () => {
    let payload = {
     
      
      
    };
    const fetchObj = {
      payload: payload,
    };
    dispatch(showLoading());
    const response = await callService(
      "POST",
      CONSTANTES.APIS_PATH.searchArea,
      fetchObj
    );
    dispatch(hideLoading());
    if (response.ok && response.data) {
      let { totalPages } = response.data;
      setPaginationData({ ...paginationData, totalPages: totalPages });

      let arrData =
        response &&
        response.data &&
        response.data.rows &&
        response.data.rows.map((item) => {
          let obj = {
            id: item.ID,
            dateTimeCreation: item.dateTimeCreation,
            name: item.name,
            email: item.email,
            emailRecepcion: item.emailRecepcion,
            estado: item.estado,
            sendMailValidation:  item.sendMailValidation? item.sendMailValidation: false,
            valEmailRecepcion:  item.valEmailRecepcion? item.valEmailRecepcion: false  
          };
          return obj;
        });
    } else {
      console.log("Error fetching data => ", response.message);
      
    }
  };

  return (
    <div className="step__content" data-key={keyIndex}>
      <div className="proveedores_content">
            <h4 className="title-05 margin-bottom-16 margin-top-16">
                <p><b>Acerca de <span class="title-red">Referencias Comerciales</span></b></p>
                <p className="title-06"><b>Especifica las referencias que cuentas:</b></p>
            </h4>
            <div className="d-justify-space-between d-flex-column-m w100">
              <div className="documents_criteria_datos">
                  <Input
                    label="Razón Social"
                    name="razonSocial"
                    maxLength="500"
                    value={(data && data.referencia[0] && data.referencia[0].razonSocial) || ''}
                    onChange={(newValue) => {(data.referencia[0]||(data.referencia[0]={})).razonSocial = newValue;                                                  
                                            handleChange("referencia", data.referencia, 0);
                                            }
                    }
                    hasError= {(validacion.referencia[0]  && validacion.referencia[0].razonSocial) && '*'}
                    customRegex={/^[a-zA-Z0-9\.\s\u00f1\u00d1\&]*$/}                     
                  />
              </div>
            </div>
            <div className="d-justify-space-between d-flex-column-m w100">
              <div className="documents_criteria_datos">
                  <Input
                    label="RUC"
                    name="numRuc"
                    maxLength="11"
                    value={(data && data.referencia[0] && data.referencia[0].numRuc) || ''}
                    onChange={(newValue) => {(data.referencia[0]||(data.referencia[0]={})).numRuc = String(newValue);                                                  
                                            handleChange("referencia", data.referencia, 0);
                                            }
                    }
                    hasError= {(validacion.referencia[0]  && validacion.referencia[0].numRuc) && '*'}
                    customRegex={/^[0-9]*$/}                      
                  />
              </div>
            </div>
            <div className="d-justify-space-between d-flex-column-m w100">
              <div className="documents_criteria_datos">
                  <Input
                    label="Nombres"
                    name="nombres"
                    maxLength="500"
                    value={(data && data.referencia[0] && data.referencia[0].nombres) || ''}
                    onChange={(newValue) => {(data.referencia[0]||(data.referencia[0]={})).nombres = newValue;                                                  
                                            handleChange("referencia", data.referencia, 0);
                                            }
                    }
                    hasError= {(validacion.referencia[0]  && validacion.referencia[0].nombres) && '*'}
                    customRegex={/^[a-zA-Z0-9\.\s\u00f1\u00d1\&]*$/}
                  />
              </div>
            </div>
            <div className="d-justify-space-between d-flex-column-m w100">
              <div className="documents_criteria_datos">
                  <Input
                    label="Apellido Paterno"
                    name="apePaterno"
                    maxLength="500"
                    value={(data && data.referencia[0] && data.referencia[0].apePaterno) || ''}
                    onChange={(newValue) => {(data.referencia[0]||(data.referencia[0]={})).apePaterno = newValue;                                                  
                                            handleChange("referencia", data.referencia, 0);
                                            }
                    }
                    hasError= {(validacion.referencia[0]  && validacion.referencia[0].apePaterno) && '*'}
                    customRegex={/^[a-zA-Z0-9\.\s\u00f1\u00d1\&]*$/}                     
                  />
              </div>
            </div>
            <div className="d-justify-space-between d-flex-column-m w100">
              <div className="documents_criteria_datos">
                  <Input
                    label="Apellido Materno"
                    name="apeMaterno"
                    maxLength="500"
                    value={(data && data.referencia[0] && data.referencia[0].apeMaterno) || ''}
                    onChange={(newValue) => {(data.referencia[0]||(data.referencia[0]={})).apeMaterno = newValue;                                                  
                                            handleChange("referencia", data.referencia, 0);
                                            }
                    }
                    hasError= {(validacion.referencia[0]  && validacion.referencia[0].apeMaterno) && '*'}
                    customRegex={/^[a-zA-Z0-9\.\s\u00f1\u00d1\&]*$/}                         
                  />
              </div>
            </div>
            <div className="d-justify-space-between d-flex-column-m w100">
              <div className="documents_criteria_datos">
                  <Input
                    label="Celular"
                    name="celular"
                    maxLength="20"
                    value={(data && data.referencia[0] && data.referencia[0].celular) || ''}
                    onChange={(newValue) => {(data.referencia[0]||(data.referencia[0]={})).celular = String(newValue);                                                  
                                            handleChange("referencia", data.referencia, 0);
                                            }
                    }
                    hasError= {(validacion.referencia[0]  && validacion.referencia[0].celular) && '*'}
                    customRegex={/^[0-9]*$/}                         
                  />
              </div>
            </div>
            <div className="d-justify-space-between d-flex-column-m w100">
              <div className="documents_criteria_datos">
                  <Input
                    label="Correo Electronico"
                    name="correo"
                    maxLength="500"
                    value={(data && data.referencia[0] && data.referencia[0].correo) || ''}
                    onChange={(newValue) => {(data.referencia[0]||(data.referencia[0]={})).correo = newValue;                                                  
                                            handleChange("referencia", data.referencia, 0);
                                            }
                    }
                    hasError= {(validacion.referencia[0]  && validacion.referencia[0].correo) && '*'}
                    customRegex={/^[a-zA-Z0-9\.\-\_@\.]*$/}       
                  />
              </div>
            </div>
            <h4 className="title-06 margin-bottom-16 margin-top-48">
                Agregar mas referencias de la empresa:
            </h4> 
            <div className="d-justify-space-between d-flex-column-m w100">
              <div className="documents_criteria_datos">
                  <Tab
                  activeTab={0}
                  options={"Referencia Adicional 1|Referencia Adicional 2"}  
                  //changeTab={tabQuestions}
                  //disabledTab={tabDisabled}
                  contents={
                  <>
                  <div className="tab__content is-active" data-key={0}>
                  <div className="documents_criteria_datostab">
                        <Input
                          label="Razón Social"
                          name="razonSocial"
                          maxLength="1000"
                          value={(data && data.referencia[1] && data.referencia[1].razonSocial) || ''}
                          onChange={(newValue) => {(data.referencia[1]||(data.referencia[1]={})).razonSocial = newValue;
                                                  handleChange("referencia", data.referencia, 1); 
                                                  }
                          }
                          hasError= {(validacion.referencia[1]  && validacion.referencia[1].razonSocial) && '*'}
                          customRegex={/^[a-zA-Z0-9\.\s\u00f1\u00d1\&]*$/}
                        />
                    </div>
                    <div className="documents_criteria_datostab">
                        <Input
                          label="RUC"
                          name="numRuc"
                          maxLength="1000"
                          value={(data && data.referencia[1] && data.referencia[1].numRuc) || ''}
                          onChange={(newValue) => {(data.referencia[1]||(data.referencia[1]={})).numRuc = String(newValue);
                                                  handleChange("referencia", data.referencia, 1); 
                                                  }
                          }
                          hasError= {(validacion.referencia[1]  && validacion.referencia[1].numRuc) && '*'}
                          customRegex={/^[0-9]*$/}
                        />
                    </div>
                    <div className="documents_criteria_datostab">
                        <Input
                          label="Nombres"
                          name="nombres"
                          maxLength="1000"
                          value={(data && data.referencia[1] && data.referencia[1].nombres) || ''}
                          onChange={(newValue) => {(data.referencia[1]||(data.referencia[1]={})).nombres = newValue;
                                                  handleChange("referencia", data.referencia, 1); 
                                                  }
                          }
                          hasError= {(validacion.referencia[1]  && validacion.referencia[1].nombres) && '*'}
                          customRegex={/^[a-zA-Z0-9\.\s\u00f1\u00d1\&]*$/}
                        />
                    </div>
                    <div className="documents_criteria_datostab">
                        <Input
                          label="Apellido Paterno"
                          name="apePaterno"
                          maxLength="1000"
                          value={(data && data.referencia[1] && data.referencia[1].apePaterno) || ''}
                          onChange={(newValue) => {(data.referencia[1]||(data.referencia[1]={})).apePaterno = newValue;
                                                  handleChange("referencia", data.referencia, 1); 
                                                  }
                          }
                          hasError= {(validacion.referencia[1]  && validacion.referencia[1].apePaterno) && '*'}
                          customRegex={/^[a-zA-Z0-9\.\s\u00f1\u00d1\&]*$/}
                        />
                    </div>
                    <div className="documents_criteria_datostab">
                        <Input
                          label="Apellido Materno"
                          name="apeMaterno"
                          maxLength="1000"
                          value={(data && data.referencia[1] && data.referencia[1].apeMaterno) || ''}
                          onChange={(newValue) => {(data.referencia[1]||(data.referencia[1]={})).apeMaterno = newValue;
                                                  handleChange("referencia", data.referencia, 1); 
                                                  }
                          }
                          hasError= {(validacion.referencia[1]  && validacion.referencia[1].apeMaterno) && '*'}
                          customRegex={/^[a-zA-Z0-9\.\s\u00f1\u00d1\&]*$/}
                        />
                    </div>
                    <div className="documents_criteria_datostab">
                        <Input
                          label="Celular"
                          name="celular"
                          maxLength="15"
                          value={(data && data.referencia[1] && data.referencia[1].celular) || ''}
                          onChange={(newValue) => {(data.referencia[1]||(data.referencia[1]={})).celular = newValue;
                                                  handleChange("referencia", data.referencia, 1); 
                                                  }
                          }
                          hasError= {(validacion.referencia[1]  && validacion.referencia[1].celular) && '*'}
                          customRegex={/^[0-9\.\s\&]*$/}
                        />
                    </div>
                    <div className="documents_criteria_datostab">
                        <Input
                          label="Correo electrónico"
                          name="correo"
                          maxLength="1000"
                          value={(data && data.referencia[1] && data.referencia[1].correo) || ''}
                          onChange={(newValue) => {(data.referencia[1]||(data.referencia[1]={})).correo = newValue;
                                                  handleChange("referencia", data.referencia, 1); 
                                                  }
                          }
                          hasError= {(validacion.referencia[1]  && validacion.referencia[1].correo) && '*'}
                          customRegex={/^[a-zA-Z0-9\.\-\_@\.]*$/}
                        />
                    </div>
                  </div>
                  <div className="tab__content" data-key={1}>
                  <div className="documents_criteria_datostab">
                        <Input
                          label="Razón Social"
                          name="razonSocial"
                          maxLength="1000"
                          value={(data && data.referencia[2] && data.referencia[2].razonSocial) || ''}
                          onChange={(newValue) => {(data.referencia[2]||(data.referencia[2]={})).razonSocial = newValue;
                                                  handleChange("referencia", data.referencia, 2); 
                                                  }
                          }
                          hasError= {(validacion.referencia[2]  && validacion.referencia[2].razonSocial) && '*'}
                          customRegex={/^[a-zA-Z0-9\.\s\u00f1\u00d1\&]*$/}
                        />
                    </div>
                    <div className="documents_criteria_datostab">
                        <Input
                          label="RUC"
                          name="numRuc"
                          maxLength="11"
                          value={(data && data.referencia[2] && data.referencia[2].numRuc) || ''}
                          onChange={(newValue) => {(data.referencia[2]||(data.referencia[2]={})).numRuc = String(newValue);
                                                  handleChange("referencia", data.referencia, 2); 
                                                  }
                          }
                          hasError= {(validacion.referencia[2]  && validacion.referencia[2].numRuc) && '*'}
                          customRegex={/^[0-9]*$/} 
                        />
                    </div>
                    <div className="documents_criteria_datostab">
                        <Input
                          label="Nombres"
                          name="nombres"
                          maxLength="1000"
                          value={(data && data.referencia[2] && data.referencia[2].nombres) || ''}
                          onChange={(newValue) => {(data.referencia[2]||(data.referencia[2]={})).nombres = newValue;
                                                  handleChange("referencia", data.referencia, 2); 
                                                  }
                          }
                          hasError= {(validacion.referencia[2]  && validacion.referencia[2].nombres) && '*'}
                          customRegex={/^[a-zA-Z0-9\.\s\u00f1\u00d1\&]*$/}
                        />
                    </div>
                    <div className="documents_criteria_datostab">
                        <Input
                          label="Apellido Paterno"
                          name="apePaterno"
                          maxLength="1000"
                          value={(data && data.referencia[2] && data.referencia[2].apePaterno) || ''}
                          onChange={(newValue) => {(data.referencia[2]||(data.referencia[2]={})).apePaterno = newValue;
                                                  handleChange("referencia", data.referencia, 2); 
                                                  }
                          }
                          hasError= {(validacion.referencia[2]  && validacion.referencia[2].apePaterno) && '*'}
                          customRegex={/^[a-zA-Z0-9\.\s\u00f1\u00d1\&]*$/}
                        />
                    </div>
                    <div className="documents_criteria_datostab">
                        <Input
                          label="Apellido Materno"
                          name="apeMaterno"
                          maxLength="1000"
                          value={(data && data.referencia[2] && data.referencia[2].apeMaterno) || ''}
                          onChange={(newValue) => {(data.referencia[2]||(data.referencia[2]={})).apeMaterno = newValue;
                                                  handleChange("referencia", data.referencia, 2); 
                                                  }
                          }
                          hasError= {(validacion.referencia[2]  && validacion.referencia[2].apeMaterno) && '*'}
                          customRegex={/^[a-zA-Z0-9\.\s\u00f1\u00d1\&]*$/}
                        />
                    </div>
                    <div className="documents_criteria_datostab">
                        <Input
                          label="Celular"
                          name="celular"
                          maxLength="15"
                          value={(data && data.referencia[2] && data.referencia[2].celular) || ''}
                          onChange={(newValue) => {(data.referencia[2]||(data.referencia[2]={})).celular = String(newValue);
                                                  handleChange("referencia", data.referencia, 2); 
                                                  }
                          }
                          hasError= {(validacion.referencia[2]  && validacion.referencia[2].celular) && '*'}
                          customRegex={/^[0-9]*$/}
                        />
                    </div>
                    <div className="documents_criteria_datostab">
                        <Input
                          label="Correo electrónico"
                          name="correo"
                          maxLength="1000"
                          value={(data && data.referencia[2] && data.referencia[2].correo) || ''}
                          onChange={(newValue) => {(data.referencia[2]||(data.referencia[2]={})).correo = newValue;
                                                  handleChange("referencia", data.referencia, 2); 
                                                  }
                          }
                          hasError= {(validacion.referencia[2]  && validacion.referencia[2].correo) && '*'}
                          customRegex={/^[a-zA-Z0-9\.\-\_@\.]*$/}
                        />
                    </div>
                  </div>
                  </>
                  }
                  >
                  </Tab>
              </div>
            </div>
            <div className="d-justify-space-between d-flex-column-m w100">
              <div className="documents_criteria_btns d-flex-end margin-bottom-16">
                <div className="documents_btnSearch">
                  <Button
                    // type="submit"
                    primary
                    size="large"
                    onClick={()=>{
                      if(validarFormulario())
                      {
                        handleActualizarFicha(data);
                        handleChangePaso(keyIndex);
                      }
                    }}
                  >
                    Continuar
                  </Button>
                </div>                  
              </div>
            </div>
      </div>
      <div className="proveedores_margen">
        <DatosProveedor data={dataT}/>       
      </div>
    </div>
  );
};


export default ProveedoresReferencia;
